import _defineProperty from "@babel/runtime/helpers/defineProperty";
import emailValidator from './type/emailValidator';
import passwordValidator from './type/passwordValidator';
import { FIELD_TYPES } from '../validationConstants';
var TYPE_VALIDATORS = _defineProperty(_defineProperty({}, FIELD_TYPES.email, emailValidator), FIELD_TYPES.password, passwordValidator);

/**
 */
export default (function (fieldValue, validationConfig) {
  // If we specifically don't want to do type validation, then immediately return null
  if (validationConfig.disableTypeValidation) return null;
  var typeValidator = TYPE_VALIDATORS[validationConfig.type];
  return typeValidator ? typeValidator(fieldValue, validationConfig) : null;
});